import { ReactNode, FC } from 'react';
import Cookies from 'universal-cookie';
import { isWindowAvailable } from 'constants/is-window-available';
import {
  COOKIE_ADVERTISING,
  COOKIE_ANALYTICS,
  COOKIE_CONSENT,
  COOKIE_FUNCTIONAL,
} from 'constants/cookies';
import { CookieConsentContext } from '.';
import { CookieConsentContextType } from '.';

type CookieConsentProviderProps = {
  children: ReactNode;
  cookieConsent: CookieConsentContextType;
};

const isCookieFlagEnabled = (cookies: Cookies, name: string) =>
  cookies.get(name, { doNotParse: true }) === '1';

const CookieConsentProvider: FC<CookieConsentProviderProps> = ({ cookieConsent, children }) => {
  let value: CookieConsentContextType = cookieConsent;

  if (isWindowAvailable) {
    const cookies = new Cookies();

    value = {
      hasConsentCookie: isCookieFlagEnabled(cookies, COOKIE_CONSENT),
      functionalCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_FUNCTIONAL),
      analyticsCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_ANALYTICS),
      advertisingCookiesAccepted: isCookieFlagEnabled(cookies, COOKIE_ADVERTISING),
    };
  }

  return <CookieConsentContext.Provider value={value}>{children}</CookieConsentContext.Provider>;
};

export default CookieConsentProvider;
